import React, { useEffect } from 'react';
import { loadRecurly, RecurlyWrapper } from '@fff-web/fff-payments';
import Toast from '@fff-web/fff-ui-shared/Toast';
import Avatar from '../Avatar/Avatar';
import PaymentInfo from '../PaymentInfo/PaymentInfo';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import ShippingAddress from '../ShippingAddress/ShippingAddress';
import styles from './PersonalInfo.module.scss';
import { trackPageView } from '../../utils/tracking';
import { useVerifyUserFlowLocation } from '../../hooks/useVerifyUserFlowLocation';

function PersonalInfo() {
  const { viewSize, recurlyLoaded } = useAppContext();
  const { verifyUserFlowLocation } = useVerifyUserFlowLocation();

  useEffect(() => {
    loadRecurly();
  }, []);

  useEffect(() => {
    verifyUserFlowLocation();
    trackPageView(window.location.pathname);
  }, []);

  return (
    <>
      <section className={`${styles.personalInfo} ${styles[viewSize]}`}>
        <p className={styles.header}>Your Information</p>
        <p className={styles.subHeader}>
          Almost done! We just need a little more information about you.
        </p>
        <Avatar />
        <ShippingAddress />
        {recurlyLoaded && (<RecurlyWrapper><PaymentInfo /></RecurlyWrapper>)}
        <Toast />
      </section>
    </>
  );
}

export default PersonalInfo;
